import React from 'react';
import { Home, Car, CreditCard } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pillars() {
  const pillars = [{
    icon: <Home size={32} className="text-brand-amber" data-id="element-150" />,
    title: 'El Hogar que Mereces',
    subtitle: 'Tu Primera Casa',
    text: 'Deja de tirar dinero en rentas que suben cada año. Preparamos tu perfil para que califiques a las mejores tasas hipotecarias y construyas tu propio patrimonio.'
  }, {
    icon: <Car size={32} className="text-brand-amber" data-id="element-151" />,
    title: 'Movilidad sin Abusos',
    subtitle: 'El Auto que Necesitas',
    text: 'Deja de pagar intereses del 20% o 25%. Un crédito saludable te permite conducir el auto que quieres con mensualidades que realmente puedes pagar.'
  }, {
    icon: <CreditCard size={32} className="text-brand-amber" data-id="element-152" />,
    title: 'Respaldo Premium',
    subtitle: 'Libertad Financiera',
    text: 'Accede a tarjetas de crédito con límites altos y beneficios exclusivos. El respaldo que necesitas para viajar, invertir o simplemente dormir tranquilo ante cualquier imprevisto.'
  }];
  return <section className="py-24 lg:py-32 bg-brand-light" data-id="element-153">
      <div className="max-w-7xl mx-auto px-6" data-id="element-154">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-155">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-156">
              <div className="flex flex-col h-full bg-white p-8 rounded-2xl shadow-sm border border-slate-100 transition-shadow hover:shadow-md" data-id="element-157">
                <div className="w-16 h-16 bg-brand-amber/10 rounded-xl flex items-center justify-center mb-6" data-id="element-158">
                  {pillar.icon}
                </div>
                <h3 className="text-sm font-semibold text-brand-amber uppercase tracking-wider mb-2" data-id="element-159">
                  {pillar.title}
                </h3>
                <h4 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-160">
                  {pillar.subtitle}
                </h4>
                <p className="text-slate-600 leading-relaxed flex-grow" data-id="element-161">
                  {pillar.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}